import moment from 'moment-jalaali';

export function toFarsiRelativeTime(dateString) {
    moment.loadPersian({ dialect: 'persian-modern' });

    const now = moment();
    const date = moment(dateString);

    const diffMinutes = now.diff(date, 'minutes');
    const diffHours = now.diff(date, 'hours');
    const diffDays = now.diff(date, 'days');

    if (diffMinutes < 1) return 'لحظاتی پیش';
    if (diffMinutes < 60) return `${toFarsiNumber(diffMinutes)} دقیقه پیش`;
    if (diffHours < 24) return `${toFarsiNumber(diffHours)} ساعت پیش`;
    if (diffDays === 0) return 'امروز';
    if (diffDays === 1) return 'دیروز';
    if (diffDays <= 7) return `${toFarsiNumber(diffDays)} روز پیش`;

    const formatted = date.format('jYYYY/jM/jD');
    return toFarsiNumber(formatted);
}

function toFarsiNumber(input) {
    const farsiDigits = '۰۱۲۳۴۵۶۷۸۹';
    return String(input).replace(/\d/g, (d) => farsiDigits[d]);
}
